<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">电池数据</span>
      <div style="flex:1;text-align: right;">
        <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
          <el-form-item :label="$t('time.timeQuery')">
            <el-date-picker v-model="queryTime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="onQuery" type="primary">{{ $t('public.query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button plain type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
          </el-form-item> -->
        </el-form>

      </div>

    </div>
    <el-divider></el-divider>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
        <el-table-column v-for="item in columns" :key="item.InterfaceField" :prop="item.InterfaceField" align="center"
          :label="item.LanguageTrans" :min-width="item.DisplayWidth ? parseInt(item.DisplayWidth) : 80"></el-table-column>
        <!-- <el-table-column prop="CarNo" align="center" label="车牌号" min-width="120"></el-table-column> -->
        <!-- <el-table-column prop="GpsDateTime" align="center" label="时间" min-width="180"></el-table-column>
        <el-table-column prop="totalCurrent" align="center" label="电池总电流(A)" min-width="120"></el-table-column>
        <el-table-column prop="maxVoltageCellId" align="center" label="最大电压单体电池代号" min-width="140"></el-table-column>
        <el-table-column prop="maxCellVoltage" align="center" label="单体电池电压最大值(V)" min-width="160"></el-table-column>
        <el-table-column prop="minCellVoltage" align="center" label="单体电池最小电压(V)" min-width="140"></el-table-column>
        <el-table-column prop="maxTempProbeId" align="center" label="最高温度探针序号" min-width="120"></el-table-column>
        <el-table-column prop="maxAllowedTemp" align="center" label="电池允许最高温度(℃)" min-width="140"></el-table-column>
        <el-table-column prop="minTempSubsystemId" align="center" label="最低温度子系统号" min-width="120"></el-table-column>
        <el-table-column prop="minTempProbeId" align="center" label="最低温度探针序号" min-width="120"></el-table-column>
        <el-table-column prop="minAllowedTemp" align="center" label="电池允许最低温度(℃)" min-width="140"></el-table-column>
        <el-table-column prop="minBatteryTemp" align="center" label="整组电池最低单体电池温度(℃)" min-width="200"></el-table-column>
        <el-table-column prop="maxBatteryTemp" align="center" label="整组电池最高单体电池温度(℃)" min-width="200"></el-table-column> -->




      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { QueryAbroadCANBattery } from '@/http/vehicle'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'EVBatteryData',
  components: {
    quickQuery
  },
  computed: {
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      size: state => state.app.size
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      loading: false,
      queryTime: undefined,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,
      columns: []

    }
  },
  mounted() {
    this.queryFieldListByFunction();
    //queryTime 默认时间为当天的
    this.queryTime = [new Date(), new Date()]
    this.beginDate = this.queryTime[0]
    this.endDate = this.queryTime[1]
    this.beginDate.setHours(0, 0, 0, 0)
    this.endDate.setHours(23, 59, 59, 999)
  },
  methods: {
    //查询自定义列显示
    queryFieldListByFunction() {
      this.$api.queryFieldListByFunction({
        "FunctionName": "EVBatteryData",
      }).then(res => {
        if (res.code == 200) {
          this.columns = res.data
        }
      })
    },
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          console.log(this.selectedVehicles[k])
          vehicles = vehicles + this.selectedVehicles[k].mobile + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = this.queryTime[0];
      this.endDate = this.queryTime[1];
      //格式化为 yyyy-MM-dd HH:mm:ss
      // this.beginDate = this.beginDate.toLocaleString().replace(/\//g, '-')
      // this.endDate = this.endDate.toLocaleString().replace(/\//g, '-')
      // console.log(this.beginDate, this.endDate)
      // this.getSelectedVehicles();
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true
      this.beginDate = this.moment(this.beginDate).format('YYYY-MM-DD HH:mm:ss')
      this.endDate = this.moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
      // 实际项目中取消注释以下代码
      QueryAbroadCANBattery({
        "BeginTime": this.beginDate,
        "Language": this.LanguageId,
        "DeviceNo": this.getSelectedVehicles(),
        "EndTime": this.endDate,
        "IsExport": isExport,
        "TimeZone": 8,
        "PageNo": this.form.PageNo, "PageSize": this.form.PageSize
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = + '电池数据.xlsx'; // 默认文件名
          // a.setAttribute(
          //     "download",
          //     "充电记录.xlsx"
          // ); // 表名，自定义
          // document.body.appendChild(a);
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.recordsTotal || 0

        }
      })



    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
/* 响应式设计 */
</style>